export const FETCH_ORG_BY_ID = 'FETCH_ORG_BY_ID';
export const ORG_DETAILS_CHANGE_REQUEST = 'ORG_DETAILS_CHANGE_REQUEST';
